import { HttpErrorResponse, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(request, next) {
    let token = localStorage.getItem('__ms_t_');
    let season = localStorage.getItem('season');
    let tokenizedRquest = request.clone();
    let token_parse=JSON.parse(token)
  
    if (token &&token_parse.hasOwnProperty('_t')) {
      token = JSON.parse(token)._t;
      tokenizedRquest = request.clone({
        setHeaders: {
          Authorization: token
        }
      });
    }

    if (season) {
     
      tokenizedRquest = request.clone({
        setHeaders: {
          'X-Season':season,
          'Authorization': token
        }
      });
    }

    return next.handle(tokenizedRquest).pipe(catchError(err => {

      if (err instanceof HttpErrorResponse ) {
        if (err.status === 401) {
          localStorage.clear()
          location.href = location.origin;
        }
        return throwError(err);
      }
    }));
  }
}
